import kioskLocationPickerUrl from '../../kiosk/kiosk-location-picker.html';
import KioskLocationPickerCtrl from '../../kiosk/KioskLocationPickerCtrl';
import config from '../../config';

export default class KioskService {
  constructor(AlertService, WindowLocation, $uibModal, $window) {
    'ngInject';

    Object.assign(this, { AlertService, WindowLocation, $uibModal, $window });
  }

  async initializeKiosk(sendRequest, httpConfig) {
    try {
      const { data: { temporary_guid } } = await sendRequest({ method: 'post', path: 'kiosks/sessions/initialize', httpConfig }); // eslint-disable-line

      const { data } = await sendRequest({ method: 'post', path: 'kiosks/sessions/start', payload: { temporary_guid } }); // eslint-disable-line
      const {
        kiosk_session: { guid, id },
        locations,
      } = data;

      const kioskHttpConfig = {
        headers: {
          Authorization: `Kiosk ${guid}`,
        },
      };

      if (locations.length > 1) {
        const modalInstance = this.$uibModal.open({
          size: '620',
          templateUrl: kioskLocationPickerUrl,
          controllerAs: 'ctrl',
          controller: KioskLocationPickerCtrl,
          resolve: {
            locations() {
              return locations;
            },
          },
        });
        const result = await modalInstance.result;
        if (result) {
          const locationIds = result.map((location) => location.id);
          await sendRequest({
            method: 'post',
            path: `kiosks/sessions/${id}`,
            payload: locationIds,
            httpConfig: kioskHttpConfig,
          });
          return guid;
        }
        return false;
      } else if (locations.length === 1) {
        await sendRequest({
          method: 'post',
          path: `kiosks/sessions/${id}`,
          payload: [locations[0].id],
          httpConfig: kioskHttpConfig,
        });
        return guid;
      }

      return false;
    } catch (e) {
      this.AlertService.danger(e.data?.message || 'Initializing kiosk failed.', e.status || null);
    }
  }

  redirectToKiosk(guid, usTimeFormat) {
    this.WindowLocation.href = `${config.SLING_KIOSK_URL}/?guid=${guid}&usTimeFormat=${usTimeFormat}`;
  }
}
